import {useSearchParams} from "react-router-dom";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {BASE_URL} from "../Const";

export default function PaymentProvider() {

    const [searchParams, setSearchParams] = useSearchParams();

    const searchTerm = searchParams.get('status');

    if (searchTerm === "completed") {
        CardShopRepository.deleteAll()
    }

    window.location.assign(BASE_URL + 'order');
}
